import { render, staticRenderFns } from "./v-pdf.vue?vue&type=template&id=56f7b8b4&scoped=true&"
import script from "./v-pdf.vue?vue&type=script&lang=js&"
export * from "./v-pdf.vue?vue&type=script&lang=js&"
import style0 from "./v-pdf.vue?vue&type=style&index=0&id=56f7b8b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f7b8b4",
  null
  
)

export default component.exports